import { signalStore } from '@ngrx/signals';
import { withDocumentReferenceMethods } from '../core/document-reference.store';
import { ChatDocumentReferenceService } from './chat-document-reference.service';

export const ChatDocumentReferenceStore = signalStore(
  { providedIn: 'root' },
  withDocumentReferenceMethods(ChatDocumentReferenceService)
);
